export const approveRequiredValues = [
  {
    id: 'NON_REQUIRED',
    title: 'Не требует согласования',
  },
  {
    id: 'PROMPTLY',
    title: 'Незамедлительная проверка, ст. 66',
  },
  {
    id: 'REQUIRED',
    title: 'Требует согласования',
  },
];
